(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-z-hero-section"] && !Shopify.designMode) return;
  try {
    

let slides = document.querySelectorAll('.slide');
let dots = document.querySelectorAll('.dot');
let currentIndex = 0;
let slideInterval = setInterval(nextSlide, 15000); // Change slide every 7 seconds

function nextSlide() {
    slides[currentIndex].classList.remove('active');
    dots[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % slides.length;
    updateSliderPosition();
}

function previousSlide() {
    slides[currentIndex].classList.remove('active');
    dots[currentIndex].classList.remove('active');
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSliderPosition();
}

function updateSliderPosition() {
    let newTransformValue = `translateX(-${currentIndex * 100}%)`;
    document.querySelector('.slider').style.transform = newTransformValue;
    slides[currentIndex].classList.add('active');
    dots[currentIndex].classList.add('active');
}

dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
        clearInterval(slideInterval);
        slides[currentIndex].classList.remove('active');
        dots[currentIndex].classList.remove('active');
        currentIndex = index;
        updateSliderPosition();
        slideInterval = setInterval(nextSlide, 15000);
    });
});

// Draggable functionality
let startX, endX;
const threshold = 50;

document.querySelector('.slider').addEventListener('mousedown', (e) => {
    startX = e.clientX;
});

document.querySelector('.slider').addEventListener('mouseup', (e) => {
    endX = e.clientX;
    if (startX > endX + threshold) {
        nextSlide();
    } else if (endX > startX + threshold) {
        previousSlide();
    }
});

document.querySelector('.slider').addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
});

document.querySelector('.slider').addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    if (startX > endX + threshold) {
        nextSlide();
    } else if (endX > startX + threshold) {
        previousSlide();
    }
});

// Prevent default behavior for images to ensure dragging works
document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('dragstart', (e) => {
        e.preventDefault();
    });
});

// Custom cursor functionality
const customCursor = document.querySelector('.custom-cursor');
const hero = document.querySelector('.hero');
const clickableElements = document.querySelectorAll('button, .dot');

hero.addEventListener('mousemove', (e) => {
    customCursor.style.left = `${e.clientX}px`;
    customCursor.style.top = `${e.clientY}px`;
    customCursor.style.transform = 'translate(-50%, -50%)'; // Center the cursor on the mouse pointer
});

hero.addEventListener('mouseenter', () => {
    customCursor.style.display = 'flex';
});

hero.addEventListener('mouseleave', () => {
    customCursor.style.display = 'none';
});

clickableElements.forEach(el => {
    el.addEventListener('mouseenter', () => {
        customCursor.textContent = "click";
        customCursor.classList.add('cursor-link-hover');
    });
    el.addEventListener('mouseleave', () => {
        customCursor.textContent = "drag";
        customCursor.classList.remove('cursor-link-hover');
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
